import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import CBPromptModal from '../../shared/CBPromptModal';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import {
  createChainMembership as _createChainMembership,
  updateChainMembership as _updateChainMembership,
  deleteChainMembership as _deleteChainMembership,
} from '../../../actions/chainActions';
import { T, cardStyle, inputStyle, inputLabelStyle, tagStyle } from './chainSettingsV2Styles';

// Vehicle groups a member workshop can service. Mirrors chain/utils.py.
const ALL_VEHICLE_GROUPS = ['light', 'heavy', 'other'];

class SettingsChainMembershipsV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddForm: false,
      formData: {
        workshop_id: '',
        vehicle_groups: ALL_VEHICLE_GROUPS,
        has_chain_care_service_deal: true,
      },
      deleteModalOpen: false,
      deleteTargetId: null,
    };
  }

  updateFormState = (changedObject) => {
    var formData = this.state.formData;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
    });
  };

  submitForm = () => {
    var formData = this.state.formData;
    var createChainMembership = this.props.createChainMembership;
    var chainId = this.props.chainId;

    createChainMembership({
      chain: chainId,
      workshop_id: formData.workshop_id,
      vehicle_groups: formData.vehicle_groups,
      has_chain_care_service_deal: formData.has_chain_care_service_deal,
    });

    this.setState({
      showAddForm: false,
      formData: {
        workshop_id: '',
        vehicle_groups: ALL_VEHICLE_GROUPS,
        has_chain_care_service_deal: true,
      },
    });
  };

  openDeleteModal = (membershipId) => {
    this.setState({ deleteModalOpen: true, deleteTargetId: membershipId });
  };

  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false, deleteTargetId: null });
  };

  confirmDelete = () => {
    var deleteChainMembership = this.props.deleteChainMembership;
    var deleteTargetId = this.state.deleteTargetId;
    if (deleteTargetId) {
      deleteChainMembership(deleteTargetId);
    }
    this.closeDeleteModal();
  };

  handleToggleCareServiceDeal = (membership) => {
    var updateChainMembership = this.props.updateChainMembership;
    updateChainMembership(membership.id, {
      has_chain_care_service_deal: !membership.has_chain_care_service_deal,
    });
  };

  handleVehicleGroupsChange = (membership, newValue) => {
    var updateChainMembership = this.props.updateChainMembership;
    // An empty selection would hide every vehicle and the API rejects it.
    if (!newValue || newValue.length === 0) {
      return;
    }
    updateChainMembership(membership.id, {
      vehicle_groups: newValue,
    });
  };

  getVehicleGroupLabel = (group) => {
    var t = this.props.t;
    switch (group) {
      case 'light': return t('vehicleTypeLight');
      case 'heavy': return t('vehicleTypeHeavy');
      case 'other': return t('vehicleTypeOther');
      default: return group;
    }
  };

  getVehicleGroupsLabel = (groups) => {
    var t = this.props.t;
    var selected = groups || [];
    if (selected.length === 0) {
      return t('vehicleTypeNone');
    }
    var hasEveryGroup = ALL_VEHICLE_GROUPS.every(function (group) {
      return selected.includes(group);
    });
    if (hasEveryGroup) {
      return t('vehicleTypeAll');
    }
    return ALL_VEHICLE_GROUPS
      .filter(function (group) { return selected.includes(group); })
      .map(this.getVehicleGroupLabel)
      .join(', ');
  };

  render() {
    var t = this.props.t;
    var chainMemberships = this.props.chainMemberships;
    var membershipsStatus = this.props.membershipsStatus;
    var user = this.props.user;
    var showAddForm = this.state.showAddForm;
    var formData = this.state.formData;
    var deleteModalOpen = this.state.deleteModalOpen;

    var chainId = this.props.chainId;
    var chain = user && user.chains && user.chains.find(function (c) { return c.id == chainId; });
    var isPartsVendor = chain && chain.chain_type === 'parts_vendor';
    var isLoading = membershipsStatus && membershipsStatus.loading;

    var vehicleGroupOptions = [
      { value: 'light', label: t('vehicleTypeLight') },
      { value: 'heavy', label: t('vehicleTypeHeavy') },
      { value: 'other', label: t('vehicleTypeOther') },
    ];

    var memberWorkshopIds = chainMemberships.map(function (m) {
      return m.workshop && m.workshop.id;
    });
    var availableWorkshops = user && user.workshops
      ? user.workshops.filter(function (ws) {
          return !memberWorkshopIds.includes(ws.id);
        })
      : [];

    var workshopOptions = availableWorkshops.map(function (ws) {
      return { value: ws.id, label: ws.name };
    });

    return (
      <CBMediaQuery>
        {screenSize => (
          <div>
            <div style={getStyle(screenSize, styles, 'headerCard')}>
              <div style={getStyle(screenSize, styles, 'headerLeft')}>
                <div style={getStyle(screenSize, styles, 'iconBox')}>
                  <i className="pi pi-wrench" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={getStyle(screenSize, styles, 'title')}>{t('chainMembershipsTitle')}</h2>
                  <p style={getStyle(screenSize, styles, 'description')}>{t('chainMembershipsDescription')}</p>
                </div>
              </div>
              {!showAddForm && workshopOptions.length > 0 && (
                <Button
                  onClick={() => this.setState({ showAddForm: true })}
                  label={t('addWorkshop')}
                  style={{
                    backgroundColor: T.accent,
                    border: 'none',
                    color: '#0077b0',
                    fontWeight: 600,
                    fontSize: 13,
                  }}
                />
              )}
            </div>

            {showAddForm && (
              <div style={getStyle(screenSize, styles, 'addForm')}>
                <CBSelectField
                  name="workshop_id"
                  value={formData.workshop_id}
                  options={workshopOptions}
                  onChange={this.updateFormState}
                  labelText={t('selectWorkshop')}
                  labelTextStyle={inputLabelStyle}
                  placeholder={t('selectWorkshopPlaceholder')}
                  optionStyle={{ color: '#000' }}
                />
                <div>
                  <span style={inputLabelStyle}>{t('vehicleTypeAccessLabel')}</span>
                  <MultiSelect
                    value={formData.vehicle_groups}
                    options={vehicleGroupOptions}
                    onChange={function (e) {
                      this.updateFormState({ target: 'vehicle_groups', value: e.value });
                    }.bind(this)}
                    placeholder={t('vehicleTypeSelectPlaceholder')}
                    display="chip"
                    style={{ width: '100%', marginTop: 4 }}
                  />
                </div>
                <div style={getStyle(screenSize, styles, 'checkboxRow')}>
                  <input
                    type="checkbox"
                    id="has_chain_care_service_deal_v2"
                    checked={formData.has_chain_care_service_deal}
                    onChange={function (e) {
                      this.updateFormState({
                        target: 'has_chain_care_service_deal',
                        value: e.target.checked,
                      });
                    }.bind(this)}
                  />
                  <label
                    htmlFor="has_chain_care_service_deal_v2"
                    style={{ color: T.textSecondary, fontSize: 14, cursor: 'pointer' }}
                  >
                    {t('hasCareServiceDealLabel')}
                  </label>
                </div>
                <div style={getStyle(screenSize, styles, 'addFormButtons')}>
                  <Button
                    onClick={this.submitForm}
                    label={t('save')}
                    disabled={!formData.workshop_id || isLoading}
                    style={{
                      backgroundColor: '#fff',
                      border: 'none',
                      color: '#0077b0',
                      fontWeight: 600,
                    }}
                  />
                  <Button
                    onClick={() => this.setState({ showAddForm: false })}
                    label={t('cancel')}
                    severity="secondary"
                    outlined
                    style={{
                      borderColor: T.inBdr,
                      color: T.textSecondary,
                    }}
                  />
                </div>
              </div>
            )}

            {isLoading && (
              <div style={{ ...cardStyle, position: 'relative', minHeight: 100 }}>
                <CBSpinnerFloating color={T.accent} />
              </div>
            )}

            {!isLoading && chainMemberships.length === 0 && (
              <div style={getStyle(screenSize, styles, 'emptyCard')}>
                <i className="pi pi-wrench" style={{ fontSize: 32, color: T.textMuted, marginBottom: 12 }} />
                <p style={{ color: T.textMuted, fontSize: 14, margin: 0 }}>
                  {t('noMemberships')}
                </p>
              </div>
            )}

            {!isLoading && (
              <div style={getStyle(screenSize, styles, 'grid')}>
                {chainMemberships.map(function (membership) {
                  var workshopName = (membership.workshop && membership.workshop.name) || ('Korjaamo #' + membership.id);
                  var workshopCity = membership.workshop && membership.workshop.city;
                  var isActive = membership.is_active !== false;

                  return (
                    <div key={membership.id} style={getStyle(screenSize, styles, 'workshopCard')}>
                      <div style={getStyle(screenSize, styles, 'workshopHeader')}>
                        <div style={{
                          ...styles.default.wsIconBox,
                          backgroundColor: isActive ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255,255,255,0.05)',
                        }}>
                          <i className="pi pi-wrench" style={{
                            fontSize: 18,
                            color: isActive ? T.accent : T.textMuted,
                          }} />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ color: T.textPrimary, fontSize: 15, fontWeight: 600 }}>
                              {workshopName}
                            </span>
                            <span style={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: isActive ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.3)',
                              display: 'inline-block',
                              flexShrink: 0,
                            }} />
                          </div>
                          {workshopCity && (
                            <div style={{ color: T.textMuted, fontSize: 12, marginTop: 2 }}>
                              {workshopCity}
                            </div>
                          )}
                        </div>
                      </div>

                      <div style={getStyle(screenSize, styles, 'tagRow')}>
                        <span style={tagStyle('default')}>
                          {this.getVehicleGroupsLabel(membership.vehicle_groups)}
                        </span>
                        {membership.has_chain_care_service_deal && (
                          <span style={tagStyle('active')}>
                            {t('careServiceDeal')}
                          </span>
                        )}
                      </div>

                      <div style={getStyle(screenSize, styles, 'workshopActions')}>
                        <MultiSelect
                          value={membership.vehicle_groups || []}
                          options={vehicleGroupOptions}
                          onChange={function (e) {
                            this.handleVehicleGroupsChange(membership, e.value);
                          }.bind(this)}
                          placeholder={t('vehicleTypeSelectPlaceholder')}
                          display="chip"
                          style={getStyle(screenSize, styles, 'multiSelectSmall')}
                        />
                        <Button
                          onClick={() => this.handleToggleCareServiceDeal(membership)}
                          label={membership.has_chain_care_service_deal ? t('disableCareService') : t('enableCareService')}
                          size="small"
                          outlined
                          style={{
                            borderColor: 'rgba(255, 255, 255, 0.25)',
                            color: membership.has_chain_care_service_deal ? '#fff' : T.textSecondary,
                            fontSize: 12,
                          }}
                        />
                        <Button
                          onClick={() => this.openDeleteModal(membership.id)}
                          icon="pi pi-trash"
                          text
                          rounded
                          style={{ color: 'rgba(255, 255, 255, 0.4)', width: 32, height: 32 }}
                        />
                      </div>
                      {isPartsVendor && (
                      <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid ' + T.borderLight }}>
                        <label style={{ ...inputLabelStyle, fontSize: 11 }}>{t('netvisorSupplierNumber')}</label>
                        <input
                          type="text"
                          defaultValue={membership.netvisor_supplier_number || ''}
                          placeholder=""
                          onBlur={function (e) {
                            var val = e.target.value;
                            if (val !== (membership.netvisor_supplier_number || '')) {
                              this.props.updateChainMembership(membership.id, { netvisor_supplier_number: val });
                            }
                          }.bind(this)}
                          style={{ ...inputStyle, height: 32, fontSize: 12 }}
                        />
                      </div>
                      )}
                    </div>
                  );
                }.bind(this))}
              </div>
            )}

            <CBPromptModal
              modalIsOpen={deleteModalOpen}
              closeModal={this.closeDeleteModal}
              performAction={this.confirmDelete}
              title={t('deleteMembershipTitle')}
              text={t('deleteMembershipText')}
              buttonText={t('deleteMembershipButton')}
            />
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    headerCard: {
      ...cardStyle,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 12,
      marginBottom: 20,
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    },
    iconBox: {
      width: 48,
      height: 48,
      borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    title: {
      color: T.textPrimary,
      fontSize: 18,
      fontWeight: 600,
      margin: 0,
    },
    description: {
      color: T.textSecondary,
      fontSize: 13,
      margin: '4px 0 0 0',
    },
    addForm: {
      ...cardStyle,
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      marginBottom: 20,
      maxWidth: 480,
    },
    checkboxRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginTop: 12,
    },
    addFormButtons: {
      display: 'flex',
      gap: 12,
      marginTop: 16,
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320, 1fr))',
      gap: 16,
    },
    workshopCard: {
      ...cardStyle,
      padding: 20,
      marginBottom: 12,
    },
    workshopHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      marginBottom: 14,
    },
    wsIconBox: {
      width: 42,
      height: 42,
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    tagRow: {
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 16,
    },
    workshopActions: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexWrap: 'wrap',
      borderTop: '1px solid ' + T.borderLight,
      paddingTop: 14,
    },
    selectSmall: {
      backgroundColor: T.inBg,
      color: T.textPrimary,
      border: '1px solid ' + T.inBdr,
      borderRadius: 6,
      padding: '6px 10px',
      fontSize: 12,
    },
    // PrimeReact MultiSelect brings its own inner padding, so this only sets
    // the shell: colours, border and the width the chips need.
    multiSelectSmall: {
      backgroundColor: T.inBg,
      color: T.textPrimary,
      border: '1px solid ' + T.inBdr,
      borderRadius: 6,
      fontSize: 12,
      minWidth: 200,
      flex: 1,
    },
    emptyCard: {
      ...cardStyle,
      textAlign: 'center',
      padding: '48px 24px',
    },
  },
  medium: {
    headerCard: {
      ...cardStyle,
      padding: 16,
      marginBottom: 12,
    },
    grid: {
      gap: 12,
    },
    workshopCard: {
      ...cardStyle,
      padding: 16,
      marginBottom: 8,
    },
    workshopActions: {
      gap: 6,
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    chainMemberships: state.chain.chainMemberships,
    membershipsStatus: state.chain.chainMembershipsStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    createChainMembership: _createChainMembership,
    updateChainMembership: _updateChainMembership,
    deleteChainMembership: _deleteChainMembership,
  },
)(translate('ChainSettingsView')(SettingsChainMembershipsV2));
